import React from 'react';
import { useTranslation } from 'react-i18next';

import Button from '../../Button';

import './style.scss';

interface SearchErrorMessageProps {
  onRetry?: () => void;
}

// Shown instead of results when a search request fails. It looks like the
// empty state, but has its own text, so it doesn't read as "no results".
const SearchErrorMessage: React.FC<SearchErrorMessageProps> = ({ onRetry }) => {
  const { t } = useTranslation();

  return (
    <div className="SearchErrorMessage" role="alert">
      <div className="SearchErrorMessage__title">
        <h2>{t('searchkit.error.title')}</h2>
      </div>
      <div className="SearchErrorMessage__body">
        <p>{t('searchkit.error.body')}</p>
      </div>
      {onRetry && (
        <Button type="secondary" onClick={onRetry}>
          {t('searchkit.error.retry')}
        </Button>
      )}
    </div>
  );
};

export default SearchErrorMessage;
